import React, { Component } from "react";
import { Box } from "@mui/material";
import { FormControl, FormGroup } from "@mui/material";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Spinner from "react-bootstrap/Spinner";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Cookies from "js-cookie";
import settings from "../../helpers/settings";
import axios from "axios";
import Select from "react-select";
import PreAuthorization from "../Authorization/PreAuthorization.js";

import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
let { KayanURL } = settings;

const allInsuraceCompanies = {
  15: "LICNS-00007",
  17: "NI/23",
  20: "NI/32",
  21: "FI/9",
  22: "LICNS-00001",
  23: "LICNS-00014",
  24: "FI/6",
  25: "TPA/004",
  26: "LICNS-202329",
  27: "TPA/003",
  28: "LICNS-2023156",
  29: "FI/35",
  30: "LICNS-202315",
  31: "FI/15",
  32: "LICNS-00013",
  33: "LICNS-2023157",
  34: "NI/37",
  35: "TPA/002",
  36: "LICNS-202314",
  45: "NI/34"
};
//gulf_user
const providers = {
  16: "PROV0031",
  19: "PRV-2582",
  3: "PRV-110098",
  100: "PRV-1538",
  21:"PRV-0031"
};
const gulfProviders = [
  { id: 16, name: "PROV0031" },
  { id: 19, name: "PRV-2582" },
  { id: 21, name: "PRV-0031" },

];
const kimsProviders = [
  { id: 3, name: "PRV-110098" },
  { id: 100, name: "PRV-1538" },
];
const kimsProvidersProd = [{ id: 100, name: "PRV-1538" }];
// const style = {
//   AuthScreen: false,
// };
// const productionPayers = (
//   <>
//     <option value="17">LIVA prod (NI/23) </option>
//     <option value="21">New India Prod (FI/9)</option>
//     <option value="20">OQIC Prod (NI/32)</option>
//     <option value="24">AXA Prod (FI/6)</option>
//     <option value="25">Mednet Prod (TPA/004)</option>
//     <option value="27">Vipul Prod (TPA/003)</option>
//     <option value="29">Damana Prod (FI/35)</option>
//     <option value="31">Metlife (FI/15)</option>
//     <option value="34">Takaful Oman Insurance Company(NI/37)</option>
//     <option value="35">Nextcare(TPA/002)</option>
//   </>
// );
// const testingPayers = (
//   <>
//     <option value="30">New India Test (LICNS-202315)</option>
//     <option value="15">OQIC Test (LICNS-00007)</option>
//     <option value="22">AXA Test (LICNS-00001)</option>
//     <option value="23">Mednet Test (LICNS-00014)</option>
//     <option value="26">Vipul Test (LICNS-202329)</option>
//     <option value="28">Damana Test (LICNS-2023156)</option>
//     <option value="32">Nextcare Test (LICNS-00013)</option>
//     <option value="33">Nextcare Insurance(LICNS-2023157)</option>
//   </>
// );
class CheckEligibility extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isTPA: false,
      purposes: [],
      // validationCheckboxFlag: false,
      // discoveryCheckboxFlag: false,
      // benefitsCheckboxFlag: false,
      // selectedValue: null
      CheckEligibilityScreen: true,
      AuthScreen: false,
      msgCheckEligiplity: "",
      // patientEligible: false
      payerOptions: [],
      eligibilityStatus: ""
    };
  }
  componentDidMount = async () => {
    this.getAllPatient();
    let currentDate = new Date();
    // currentDate.setUTCHours(currentDate.getUTCHours() + 4);
    // let formattedDateTime = `${currentDate.getFullYear()}-${String(
    //   currentDate.getMonth() + 1
    // ).padStart(2, "0")}
    // -${String(currentDate.getUTCDate()).padStart(2, "0")}T${String(
    //   currentDate.getUTCHours()
    // ).padStart(2, "0")}:
    // ${String(currentDate.getUTCMinutes()).padStart(2, "0")}`;
    let formattedDateTime = `${currentDate.getFullYear()}-${String(
      currentDate.getMonth() + 1
    ).padStart(2, "0")}-${String(currentDate.getDate()).padStart(2, "0")}`;
    let newIdentifier = Date.now();
    this.setState({ servicedDate: formattedDateTime });
  };
  getAllPatient = async () => {
    let response = await axios.put(
      KayanURL + "/test/patients/getPatient",

      {
        apiToken: Cookies.get("id"),
      }
    );
    if (response) {
      let { data } = response;
      if (data) {
        let { success } = data;
        if (success) {
          this.setState({ AllPatients: data.patient });
        }
      }
    }
  };
  getCoverageInfoByPayerNameAndPatientID = async (payerName) => {
    let response = await axios.put(
      KayanURL + "/test/patients/getCoverageInfoByPayerName",

      {
        apiToken: Cookies.get("id"),
        payerName: payerName,
        patientId: this.state.selectedPatient.id
      }
    );
    if (response) {
      let { data } = response;
      if (data) {
        let { success } = data;
        if (success) {
          let coverageInfoByPayerName = data.eligibilityInfoByPayerName;
          coverageInfoByPayerName.sort((a, b) => a.id - b.id);
          this.setState({ coverageInfoByPayerName: coverageInfoByPayerName[coverageInfoByPayerName.length - 1] });
        }
      }
    }
  };
  // getAllPatientEligibilityInfo = async (selectedPatientID) => {
  //   this.setState({ loading: true });
  //   let { allPatients, selectedPatient } = this.state;
  //   let response = await axios.put(
  //     KayanURL + "/test/patients/getPatientEligibilityInfo",

  //     {
  //       apiToken: Cookies.get("id"),
  //     }
  //   );
  //   console.log(selectedPatient, "selectedPatient in getting patient");

  //   if (response && response.data) {
  //     const { success, eligibilityHistory } = response.data;

  //     let filteredPatients;
  //     if (selectedPatientID) {
  //       filteredPatients = eligibilityHistory.filter(patient => patient.patient_id === selectedPatientID);
  //     }
  //     console.log(filteredPatients, "filteredPatients")

  //     if (filteredPatients.length > 0) {
  //       const sortedByID = filteredPatients.map((patient, index) => ({
  //         index, patient,
  //       })).sort((a, b) =>
  //         new Date(b.patient.formatteddatetime).toISOString()
  //           .localeCompare(new Date(a.patient.formatteddatetime).toISOString())
  //       ).map((pair) => pair.patient);
  //       // console.log(sortedByID,"sorted")
  //       if (sortedByID[0].disposition == "Coverage is in-force") {
  //         this.setState({
  //           selectedPatient: sortedByID[0],
  //           patientEligible: true,
  //           loading: false,
  //         });
  //       } else {
  //         this.setState({
  //           selectedPatient: sortedByID[0],
  //           patientEligible: false,
  //           loading: false,
  //         });
  //       }
  //     }

  //   } else {
  //     this.setState({ loading: false });
  //   }
  // };
  onSelectValue = async (e) => {
    this.setState({ selectedPatientID: e.value });
    let allPatients = this.state.AllPatients;

    let selectedPatient = allPatients.filter((p) => {
      return p.profile_id === e.value;
    });

    if (selectedPatient && selectedPatient.length > 0) {
      console.log(selectedPatient, "nnnnnnnnnnnnnnnnn");
      // await this.getAllPatientEligibilityInfo(selectedPatient[0].id)
      this.setState({
        selectedPatient: selectedPatient[0],
        displayPatientInfo: true,
        // selectedValue: { value: selectedPatient[0].profile_id, label: selectedPatient[0].first_name + " " + selectedPatient[0].last_name },
        insurance: [],
        coverageInfo: {},
        coverageInfoByPayerName: [],
        patientInfo: [],
        payerId: "",
        payerName: ""
      });
    } else {
      this.setState({ displayPatientInfo: false });
    }
  };
  openPreAuthScreen = (e) => {
    e.preventDefault();
    this.setState({
      AuthScreen: true,
      CheckEligibilityScreen: false,
    });
  };
  handleCheckBoxChange = (e) => {
    // let value = e.target.value;
    let { name, checked, value } = e.target;
    let { purposes } = this.state;
    let index = purposes.indexOf(value);
    if (name === "isTPA") {
      checked
        ? this.setState({ isTPA: true })
        : this.setState({ isTPA: false });
    } else {
      if (checked) {
        purposes.push(value);
        // if (value === "validation") {
        //   // this.setState({ validationCheckboxFlag: true });
        // } else if (value === "discovery") {
        //   this.setState({ discoveryCheckboxFlag: true })
        // } else if (value === "benefits") {
        //   this.setState({ benefitsCheckboxFlag: true })
        // }
        this.setState({ purposes });
      } else {
        purposes.splice(index, 1);
        // if (value === "validation") {
        //   this.setState({ validationCheckboxFlag: false });
        // } else if (value === "discovery") {
        //   this.setState({ discoveryCheckboxFlag: false })
        // } else if (value === "benefits") {
        //   this.setState({ benefitsCheckboxFlag: false })
        // }
        this.setState({ purposes });
      }
      if (purposes.includes('discovery')) {
        this.setState({
          coverageInfoByPayerName: []
        })
      } else if(purposes.includes('validation')||purposes.includes('benefits')){
        this.getCoverageInfoByPayerNameAndPatientID(this.state.payerName)
      }
    }
  };
  HandleInputTextChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    if (name === "payerId") {
      this.setState({
        payerName: allInsuraceCompanies[[value]],
        payerId: value,
      });
      this.getCoverageInfoByPayerNameAndPatientID(allInsuraceCompanies[[value]]);
    } else if (name === "specificIns") {
      this.setState({
        // specificInsName: allInsuraceCompanies[[value]],
        specificIns: allInsuraceCompanies[[value]],
      });
    } else if (name === "providerId") {
      this.setState({
        providerName: providers[[value]],
        providerId: value,

        // payerOptions: value === "PROV0031" ? testingPayers : value === "PRV-2582" ? productionPayers : [],
      });
    } else {
      this.setState({ [name]: value });
    }
  };
  handleCheckEligibility = async (e) => {
    e.preventDefault();
    let { selectedPatient,coverageInfoByPayerName } = this.state;
    this.setState({
      requestSent: true,
      eligibilityResponse: false,
      response: "",
      eligibilityError: "",
      eligibilityStatus: "",
    });

    let patient = {
      firstName: this.state.selectedPatient.first_name,
      lastName: this.state.selectedPatient.last_name,
      identifier: this.state.selectedPatient.identifier,
      profileId: this.state.selectedPatient.profile_id,
      gender: this.state.selectedPatient.gender,
      birthDate: this.state.selectedPatient.birthdate,
      phone: this.state.selectedPatient.phone,
      identifierType: this.state.selectedPatient.identifier_type,
      country: this.state.selectedPatient.country,
    };

    try {
      let CheckEligibilityResponse = await axios.post(
        "https://om.kayan-healthcare.com/test/comp/request",
        {
          apiToken: Cookies.get("id"),
          requestType: "1",
          content: {
            payerName: this.state.payerName,
            purpose: this.state.purposes,
            ...(coverageInfoByPayerName.coverage && { coverage: coverageInfoByPayerName.coverage }),
            servicedDate: this.state.servicedDate,
            patientId: this.state.selectedPatient.profile_id,
            payerId: this.state.payerId,
            providerId: this.state.providerId,
            providerName: this.state.providerName,
            patient: patient,
            specificIns: this.state.specificIns,
            isTPA: this.state.isTPA,
            // specificInsName: this.state.specificInsName,
          },
        }
      );

      if (CheckEligibilityResponse) {
        this.setState({
          requestSent: false,
          eligibilityResponse: true,
        });

        let { data } = CheckEligibilityResponse;
        // console.log(data, 'dataaaa');

        if (data) {
          let { success, response, error, HL7Request } = data;
          this.setState({ HL7Request: JSON.parse(HL7Request) });

          if (success) {
            let { fullResponse } = data;
            let insuranceItems, disposition;
            let {
              insurance,
              patient,
              coverage,
              eligibility_response_identifier,
            } = data.response;

            if (insurance && insurance.length > 0) {
              disposition = insurance[0].disposition;
              insuranceItems = insurance[0].insuranceItems;
              this.setState({ insurance, eligibilityStatus: disposition });
            }

            this.addEligibilityInfo(
              eligibility_response_identifier,
              coverage,
              fullResponse,
              insuranceItems,
              disposition,
              this.state.specificIns
            );

            if (patient && patient.length > 0) {
              this.setState({ patientInfo: patient });
            }

            if (coverage && coverage.bundleId !== undefined) {
              coverage["disposition"] = disposition;
              selectedPatient["coverage"] = coverage;
              selectedPatient["payer_name"] = this.state.payerName;
              selectedPatient["provider_name"] = this.state.providerName;
              selectedPatient["payer_id"] = this.state.payerId;
              this.setState({ coverageInfo: coverage });
            }
          } else {
            this.setState({
              response,
              patientInfo: [],
              coverageInfo: {},
              insurance: [],
              eligibilityError: response ? response : error
            });
          }
        }
        this.setState({
          coverageInfoByPayerName: []
        })
      }
    } catch (error) {
      let errorMessage = "An error occurred while checking eligibility. Please try again later.";
      if (error.message.includes("400")) {
        errorMessage = "Server is not responding.";
      } else if (error.message.includes("500")) {
        errorMessage = "There is an internal server error. Please contact the IT team to resolve this issue.";
      }
      console.log("Error in checking eligibility:", error);
      this.setState({
        requestSent: false,
        eligibilityResponse: true,
        eligibilityError: errorMessage,
        specificIns: ""
      });
    }
  };


  addEligibilityInfo = async (
    eligibility_response_identifier,
    coverage,
    fullResponse,
    insuranceItems,
    disposition,
    tpa
  ) => {
    // let currentDate = new Date();
    // let formattedDateTime = `${currentDate.getFullYear()}-${String(
    //   currentDate.getMonth() + 1
    // ).padStart(2, "0")}-${String(currentDate.getDate()).padStart(
    //   2,
    //   "0"
    // )} ${String(currentDate.getHours()).padStart(2, "0")}:${String(
    //   currentDate.getMinutes()
    // ).padStart(2, "0")}:${String(currentDate.getSeconds()).padStart(2, "0")}`;
    let currentDate = new Date();
    //currentDate.setUTCHours(currentDate.getUTCHours() + 4);
    let formattedDateTime = `${currentDate.getFullYear()}-${String(
      currentDate.getMonth() + 1
    ).padStart(2, "0")}-${String(currentDate.getDate()).padStart(
      2,
      "0"
    )} ${String(currentDate.getHours()).padStart(2, "0")}:${String(
      currentDate.getMinutes()
    ).padStart(2, "0")}:${String(currentDate.getSeconds()).padStart(2, "0")}`;
    try {
      let response = await axios.put(
        KayanURL + "/test/patients/addEligibility",
        {
          apiToken: Cookies.get("id"),
          eligibility: {
            patient_id: this.state.selectedPatient.id,
            payer_id: this.state.payerId,
            payer_name: this.state.payerName,
            provider_id: this.state.providerId,
            provider_name: this.state.providerName,
            service_date: this.state.servicedDate,
            eligibility_response_identifier: eligibility_response_identifier,
            coverage: coverage,
            disposition: disposition,
            items: insuranceItems,
            hl7_response: fullResponse,
            formattedDateTime: new Date(),
            tpa: tpa
          },
        }
      );
      if (response) {
        let { data } = response;
        if (data) {
          let { success, error } = data;
          if (success) {
            console.log(success);
          } else {
            console.log(error);
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  downloadJsonFile = () => {
    const blob = new Blob([JSON.stringify(this.state.HL7Request, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'data.json';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  render() {
    let { selectedPatient, insurance, patientInfo, coverageInfo, AllPatients, selectedValue, coverageInfoByPayerName } =
      this.state;
    //  console.log(coverageInfo,"selectedPatient in check")
    const { providerId } = this.state;
    console.log("coverageInfooooooo", coverageInfoByPayerName)

    // console.log(selectedPatient,"selectedPatient,,,,,,,,,,,,,,,,")
    let allInsuranceRows = [];
    let PatientRows = [];
    let CoverageData;
    let CoverageHistoryData;
    let options = [];
    if (AllPatients) {
      for (let i = 0; i < AllPatients.length; i++) {
        options.push({
          value: AllPatients[i].profile_id,
          label: AllPatients[i].first_name + " " + AllPatients[i].last_name,
        });
      }
    }

    if (insurance && insurance.length > 0) {
      allInsuranceRows = insurance.map((element, index) => {
        return (
          <TableRow key={index}>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.bundleId}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.outcome}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.status}
            </TableCell>

            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.created}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.serviceData}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.disposition}
            </TableCell>
          </TableRow>
        );
      });
    }
    if (patientInfo && patientInfo.length > 0) {
      PatientRows = patientInfo.map((element, index) => {
        return (
          <TableRow key={index}>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.profileId}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.country}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.identifierType}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.identifier}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.firstName} {element.lastName}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.gender}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.birthDate}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.phone}
            </TableCell>
          </TableRow>
        );
      });
    }
    if (coverageInfoByPayerName && coverageInfoByPayerName.coverage) {
      console.log('hhhhhhhhhhhhhhhhhhhhhhhhhhh', coverageInfoByPayerName.coverage)
      let coverageInfo = coverageInfoByPayerName.coverage;
      coverageInfo.disposition=coverageInfoByPayerName.disposition;
      CoverageHistoryData = (
        <>
          <TableRow key={coverageInfo.id}>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {coverageInfo.bundleId}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {coverageInfo.class[0].type}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {coverageInfo.class[0].value}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {coverageInfo.coverageEligibilityRequestId}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {coverageInfo.fullUrl}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {coverageInfo.id}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {coverageInfo.memberId}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {coverageInfo.messageId}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {coverageInfo.patientId}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {coverageInfo.relationship}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {coverageInfo.status}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {coverageInfo.disposition}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {coverageInfo.period.start}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {coverageInfo.period.end}{" "}
            </TableCell>
          </TableRow>
        </>
      );
    }
    console.log(coverageInfo, 'infoooooooo')
    if (coverageInfo && coverageInfo.bundleId != undefined) {
      CoverageData = (
        <>
          <TableRow key={coverageInfo.id}>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {coverageInfo.bundleId}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {coverageInfo.class[0].type}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {coverageInfo.class[0].value}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {coverageInfo.coverageEligibilityRequestId}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {coverageInfo.fullUrl}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {coverageInfo.id}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {coverageInfo.memberId}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {coverageInfo.messageId}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {coverageInfo.patientId}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {coverageInfo.relationship}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {coverageInfo.status}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {coverageInfo.disposition}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {coverageInfo.period.start}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {coverageInfo.period.end}{" "}
            </TableCell>
          </TableRow>
        </>
      );
    }
    const productionPayers = (
      <>
        <option value="17">LIVA prod (NI/23) </option>
        <option value="21">New India Prod (FI/9)</option>
        <option value="20">OQIC Prod (NI/32)</option>
        <option value="24">AXA Prod (FI/6)</option>
        <option value="25">Mednet Prod (TPA/004)</option>
        <option value="27">Vipul Prod (TPA/003)</option>
        <option value="29">Damana Prod (FI/35)</option>
        <option value="31">Metlife (FI/15)</option>
        <option value="34">Takaful Oman Insurance Company(NI/37)</option>
        <option value="35">Nextcare(TPA/002)</option>
        {/* NewLicense */}
        <option value="40">Flacon(NI/33)</option>
        <option value="41">Sukoon(FI/32)</option>
        <option value="42">Muscat(NI/38)</option>
        <option value="43">Orient(FI/34)</option>
        <option value="44">Dhofar(NI/21)</option>
        <option value="45">AlMadina(NI/34)</option>
        <option value="46">OmanUnited(NI/20)</option>









      </>
    );
    const testingPayers = (
      <>
        <option value="30">New India Test (LICNS-202315)</option>
        <option value="15">OQIC Test (LICNS-00007)</option>
        <option value="22">AXA Test (LICNS-00001)</option>
        <option value="23">Mednet Test (LICNS-00014)</option>
        <option value="26">Vipul Test (LICNS-202329)</option>
        <option value="28">Damana Test (LICNS-2023156)</option>
        <option value="32">Nextcare Test (LICNS-00013)</option>
        <option value="33">Nextcare Insurance (LICNS-2023157)</option>
        <option value="17">LIVA prod (NI/23) </option>
        <option value="34">Takaful Oman Insurance Company(NI/37)</option>
        <option value="36">MetLife (LICNS-202314)</option>

      </>
    );
    let payerOptions = [];
    if (providerId === '16' || providerId === '21') {
      payerOptions = testingPayers;
    } else if (providerId === '19') {
      payerOptions = productionPayers;
    }

    return (
      <>
        <Box height={60} />
        {this.state.CheckEligibilityScreen ? (
          <div
            style={{
              textAlign: "left",
              boxShadow: "1px solid grey",
              padding: "15px",
              boxShadow:
                "0px 2px 4px -1px rgba(0,0,0,0.3),0px 4px 5px 0px rgba(0,0,0,0.15),0px 1px 10px 0px rgba(0,0,0,0.11)",
              borderRadius: "10px",
            }}
          >
            <div>
              <div
                style={{ width: "90%", margin: "auto", padding: "20px" }}
              ></div>
              <div style={{ width: "100%", margin: "auto", padding: "20px" }}>
                <FormControl style={{ width: "75%" }}>
                  <Container>
                    <Row>
                      <Col>
                        <div id="form-group">
                          <Form.Label style={{ fontSize: "13px" }}>
                            Patients *
                          </Form.Label>
                          <Select
                            className="mb-3"
                            onChange={(e) => this.onSelectValue(e)}
                            options={options}
                            isSearchable="true"
                            // value={selectedValue}
                            required
                          ></Select>
                        </div>
                        <div
                          style={{
                            backgroundColor: "#f2f2f2",
                            margin: "auto",
                            padding: "20px",
                            width: "100%",
                          }}
                        >
                          {this.state.displayPatientInfo ? (
                            <>
                              <div
                                style={{ display: "flex", borderRadius: "5px" }}
                              >
                                <div style={{ flex: 1, marginRight: "10px" }}>
                                  <Typography
                                    id="modal-modal-title"
                                    variant="h6"
                                    component="h2"
                                    style={{ fontSize: "10px" }}
                                  >
                                    Name: {this.state.selectedPatient.first_name}{" "}
                                    {this.state.selectedPatient.last_name}
                                  </Typography>
                                  <Typography
                                    id="modal-modal-title"
                                    variant="h6"
                                    component="h2"
                                    style={{ fontSize: "10px" }}
                                  >
                                    Profile ID:{" "}
                                    {this.state.selectedPatient.profile_id}
                                  </Typography>
                                  <Typography
                                    id="modal-modal-title"
                                    variant="h6"
                                    component="h2"
                                    style={{ fontSize: "10px" }}
                                  >
                                    Birth Date:{" "}
                                    {this.state.selectedPatient.birthdate}
                                  </Typography>
                                  <Typography
                                    id="modal-modal-title"
                                    variant="h6"
                                    component="h2"
                                    style={{ fontSize: "10px" }}
                                  >
                                    Country: {this.state.selectedPatient.country}
                                  </Typography>
                                </div>
                                <div style={{ flex: 1 }}>
                                  <Typography
                                    id="modal-modal-title"
                                    variant="h6"
                                    component="h2"
                                    style={{ fontSize: "10px" }}
                                  >
                                    Identifier Type:{" "}
                                    {this.state.selectedPatient.identifier_type}
                                  </Typography>
                                  <Typography
                                    id="modal-modal-title"
                                    variant="h6"
                                    component="h2"
                                    style={{ fontSize: "10px" }}
                                  >
                                    Identifier:{" "}
                                    {this.state.selectedPatient.identifier}
                                  </Typography>
                                  <Typography
                                    id="modal-modal-title"
                                    variant="h6"
                                    component="h2"
                                    style={{ fontSize: "10px" }}
                                  >
                                    Phone: {this.state.selectedPatient.phone}
                                  </Typography>
                                  <Typography
                                    id="modal-modal-title"
                                    variant="h6"
                                    component="h2"
                                    style={{ fontSize: "10px" }}
                                  >
                                    Gender: {this.state.selectedPatient.gender}
                                  </Typography>
                                </div>
                              </div>
                            </>
                          ) : null}
                        </div>
                      </Col>

                      <Col>
                        <Form.Group className="mb-3">
                          <Form.Label style={{ fontSize: "13px" }}>
                            Provider ID *
                          </Form.Label>
                          <Form.Select
                            onChange={this.HandleInputTextChange}
                            required
                            name="providerId"
                          // value={this.state.providerId}
                          >
                            <option value="0">select...</option>
                            {Cookies.get("user_name") === "gulf_user" ? (
                              <>
                                {gulfProviders.map((element, index) => {
                                  return (
                                    <>
                                      <option value={element.id}>
                                        {element.name}
                                      </option>
                                    </>
                                  );
                                })}
                              </>
                            ) : Cookies.get("user_name").includes("kims_test") ? (
                              <>
                                {kimsProviders.map((element, index) => {
                                  return (
                                    <>
                                      <option value={element.id}>
                                        {element.name}
                                      </option>
                                    </>
                                  );
                                })}
                              </>
                            ) : Cookies.get("user_name").includes("kims_user") ? (
                              <>
                                {kimsProvidersProd.map((element, index) => {
                                  return (
                                    <>
                                      <option value={element.id}>
                                        {element.name}
                                      </option>
                                    </>
                                  );
                                })}
                              </>
                            ) : null}
                          </Form.Select>
                        </Form.Group>
                        <Form.Group className="mb-3">
                          <Form.Label style={{ fontSize: "13px" }}>
                            Serviced Date *
                          </Form.Label>
                          <Form.Control
                            type="date"
                            name="servicedDate"
                            onChange={this.HandleInputTextChange}
                            required
                            value={this.state.servicedDate}
                          />
                        </Form.Group>
                        <div>
                          <Form.Group className="mb-3">
                            <Form.Label style={{ fontSize: "13px" }}>
                              Payer ID *
                            </Form.Label>
                            <Form.Select
                              onChange={this.HandleInputTextChange}
                              required
                              name="payerId"
                            >

                              {Cookies.get("user_name").includes("gulf_user") ? (
                                <>
                                  <option value="0">select...</option>
                                  {payerOptions}
                                </>
                              ) : Cookies.get("user_name").includes("kims_user") ? (
                                <>
                                  <option value="0">select...</option>
                                  {productionPayers}
                                </>
                              ) : (
                                <>
                                  <option value="0">select...</option>
                                  {testingPayers}
                                  {productionPayers}
                                </>
                              )}
                            </Form.Select>
                            {/* <Form.Select
                              onChange={this.HandleInputTextChange}
                              required
                              name="payerId"
                            // value={this.state.payerId}
                            >
                              {Cookies.get("user_name").includes("kims_user") ? (
                                <>
                                  <option value="0">select...</option>
                                  {productionPayers}
                                </>
                              ) : (
                                <>
                                  <option value="0">select...</option>
                                  {testingPayers}
                                  {productionPayers}
                                </>
                              )}
                            </Form.Select> */}
                            <input
                              style={{ marginTop: "20px" }}
                              type="checkbox"
                              name="isTPA"
                              onChange={(e) => this.handleCheckBoxChange(e)}
                            />
                            <span style={{ fontSize: "13px" }}> is TPA</span>
                            {this.state.isTPA && (
                              <Form.Select
                                onChange={this.HandleInputTextChange}
                                // required
                                name="specificIns"
                              >
                                {Cookies.get("user_name").includes(
                                  "kims_user"
                                ) ? (
                                  <>
                                    <option value="0">select...</option>
                                    {productionPayers}
                                  </>
                                ) : (
                                  <>
                                    <option value="0">select...</option>
                                    {productionPayers}
                                    {testingPayers}
                                  </>
                                )}
                              </Form.Select>
                            )}
                          </Form.Group>
                        </div>

                        <div style={{ margin: "20px 0" }}>
                          <input
                            type="checkbox"
                            name="validation"
                            value="validation"
                            // checked={this.state.validationCheckboxFlag}
                            onChange={(e) => this.handleCheckBoxChange(e)}
                          />
                          <span style={{ fontSize: "13px" }}>Validation</span>
                          <input
                            style={{ marginLeft: "20px" }}
                            type="checkbox"
                            name="discovery"
                            value="discovery"
                            // checked={this.state.discoveryCheckboxFlag}
                            onChange={(e) => this.handleCheckBoxChange(e)}
                          />
                          <span style={{ fontSize: "13px" }}>Discovery</span>
                          <input
                            style={{ marginLeft: "20px" }}
                            type="checkbox"
                            name="benefits"
                            value="benefits"
                            // checked={this.state.benefitsCheckboxFlag}
                            onChange={(e) => this.handleCheckBoxChange(e)}
                          />
                          <span style={{ fontSize: "13px" }}>Benefits</span>

                          <div></div>
                        </div>
                      </Col>
                    </Row>

                    <div style={{ marginTop: "15px" }}>


                      {this.state.CheckEligibilityScreen && this.state.msgCheckEligiplity ? (
                        <div style={{ marginTop: "15px", color: "red" }}>
                          {this.state.msgCheckEligiplity}
                        </div>
                      ) : null}

                      <div>

                      </div>
                    </div>

                  </Container>
                 
                </FormControl>
                <div>
                {(this.state.coverageInfoByPayerName && this.state.coverageInfoByPayerName.coverage)
                    && CoverageHistoryData ? (
                    <>
                      <hr />
                      <Typography
                        id="modal-modal-title"
                        variant="h6"
                        component="h2"
                        style={{ textAlign: "left" }}
                      >
                        this patient has coverage in this payer
                      </Typography>
                      <TableContainer
                        component={Paper}
                        style={{
                          margin: "auto",
                          marginTop: "10px",
                          width: "100%",
                        }}
                      >
                        <Table aria-label="simple table">
                          <TableHead style={{ backgroundColor: "#fafafa" }}>
                            <TableRow style={{ textAlign: "center" }}>
                              <TableCell align="center">bundle ID</TableCell>
                              <TableCell align="center">Class Type</TableCell>
                              <TableCell align="center">Class Value</TableCell>
                              <TableCell align="center">
                                Coverage Eligibility Request ID
                              </TableCell>
                              <TableCell align="center">Full URL</TableCell>
                              <TableCell align="center">Coverage ID</TableCell>
                              <TableCell align="center">Member ID</TableCell>
                              <TableCell align="center">Message ID</TableCell>
                              <TableCell align="center">Patient ID</TableCell>
                              <TableCell align="center">Relationship</TableCell>
                              <TableCell align="center">Status</TableCell>
                              <TableCell align="center">Disposition</TableCell>
                              <TableCell align="center">Start Data</TableCell>
                              <TableCell align="center">End Data</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>{CoverageHistoryData}</TableBody>
                        </Table>
                      </TableContainer>
                      <hr />
                    </>
                  ) : null}
                  <Button
                    variant="primary"
                    type="submit"
                    onClick={(e) => this.handleCheckEligibility(e)}
                    style={{
                      width: "25%",
                      marginTop: "20px",
                      backgroundColor: "rgb(78 75 75)",
                      border: "1px solid rgb(78 75 75)",
                    }}
                  >
                    Check Eligibility
                  </Button>
                </div>
                <div>
                  {this.state.requestSent && !this.state.eligibilityResponse ? (
                    <div style={{ textAlign: "center", marginTop: "10px" }}>
                      <Spinner animation="border" variant="success" />
                    </div>
                  ) : this.state.eligibilityResponse &&
                    this.state.eligibilityError ? (
                    <h5 style={{ color: "red", textAlign: "center" }}>
                      {this.state.eligibilityError}
                    </h5>
                  ) : null}
                  <hr />

                  {patientInfo && patientInfo.length > 0 ? (
                    <>

                      <Typography
                        id="modal-modal-title"
                        variant="h6"
                        component="h2"
                        style={{ textAlign: "center" }}
                      >
                        Patient Information
                      </Typography>
                      <TableContainer
                        component={Paper}
                        style={{
                          margin: "auto",
                          marginTop: "30px",
                          width: "100%",
                        }}
                      >
                        <Table aria-label="simple table">
                          <TableHead style={{ backgroundColor: "#fafafa" }}>
                            <TableRow style={{ textAlign: "center" }}>
                              <TableCell align="center">Profile ID</TableCell>
                              <TableCell align="center">Country</TableCell>
                              <TableCell align="center">
                                Identifier Type
                              </TableCell>
                              <TableCell align="center">Identifier</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="center">Gender</TableCell>
                              <TableCell align="center">Birth Date</TableCell>
                              <TableCell align="center">Phone</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>{PatientRows}</TableBody>
                        </Table>
                      </TableContainer>
                    </>
                  ) : null}
                  {CoverageData && this.state.eligibilityResponse ? (
                    <>
                      <Typography
                        id="modal-modal-title"
                        variant="h6"
                        component="h2"
                        style={{ textAlign: "center" }}
                      >
                        Coverage Info
                      </Typography>
                      <TableContainer
                        component={Paper}
                        style={{
                          margin: "auto",
                          marginTop: "30px",
                          width: "100%",
                        }}
                      >
                        <Table aria-label="simple table">
                          <TableHead style={{ backgroundColor: "#fafafa" }}>
                            <TableRow style={{ textAlign: "center" }}>
                              <TableCell align="center">bundle ID</TableCell>
                              <TableCell align="center">Class Type</TableCell>
                              <TableCell align="center">Class Value</TableCell>
                              <TableCell align="center">
                                Coverage Eligibility Request ID
                              </TableCell>
                              <TableCell align="center">Full URL</TableCell>
                              <TableCell align="center">Coverage ID</TableCell>
                              <TableCell align="center">Member ID</TableCell>
                              <TableCell align="center">Message ID</TableCell>
                              <TableCell align="center">Patient ID</TableCell>
                              <TableCell align="center">Relationship</TableCell>
                              <TableCell align="center">Status</TableCell>
                              <TableCell align="center">Disposition</TableCell>
                              <TableCell align="center">Start Data</TableCell>
                              <TableCell align="center">End Data</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>{CoverageData}</TableBody>
                        </Table>
                      </TableContainer>
                    </>
                  ) : null}
                  {insurance && insurance.length > 0 ? (
                    <>
                      <Typography
                        id="modal-modal-title"
                        variant="h6"
                        component="h2"
                        style={{ textAlign: "center" }}
                      >
                        Insurance Information
                      </Typography>
                      <TableContainer
                        component={Paper}
                        style={{
                          margin: "auto",
                          marginTop: "30px",
                          width: "100%",
                        }}
                      >
                        <Table aria-label="simple table">
                          <TableHead style={{ backgroundColor: "#fafafa" }}>
                            <TableRow style={{ textAlign: "center" }}>
                              <TableCell align="center">Bundle ID</TableCell>
                              <TableCell align="center">Outcome</TableCell>
                              <TableCell align="center">Status</TableCell>
                              <TableCell align="center">Created</TableCell>
                              <TableCell align="center">Service Date</TableCell>
                              <TableCell align="center">Disposition</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>{allInsuranceRows}</TableBody>
                        </Table>
                      </TableContainer>
                    </>
                  ) : null}
                  <div style={{ width: "50%" }}>
                    {this.state.eligibilityStatus === "Coverage is in-force" ? (
                      <Button
                        variant="primary"
                        type="submit"
                        onClick={(e) => this.openPreAuthScreen(e)}
                        style={{
                          marginRight: "5px",
                          width: "30%",
                          marginTop: "15px",
                          backgroundColor: "rgb(78 75 75)",
                          border: "1px solid rgb(78 75 75)",
                        }}
                      >
                        PreAuthorization
                      </Button>
                    ) : null}
                    {this.state.HL7Request ? (
                      <>

                        <Button
                          variant="primary"
                          type="submit"
                          onClick={() => this.downloadJsonFile()}
                          style={{
                            width: "30%",
                            backgroundColor: "blue",
                            border: "1px solid blue", marginTop: "15px",
                            fontSize: "11px"
                          }}
                        >
                          Download JSON Request <ArrowDownwardIcon />
                        </Button>
                      </>
                    ) : null}
                  </div>

                </div>
              </div>
            </div>
          </div>
        ) : null}
        {this.state.AuthScreen && !this.state.CheckEligibilityScreen ? (
          <>
            <PreAuthorization
              selectedPatient={this.state.selectedPatient}
              flag="true"
              tpa={this.state.specificIns ? this.state.specificIns : ""}
            />
          </>
        ) : null}
      </>

    );
  }
}
export default CheckEligibility;
